// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';

export type ProgressBarProps = {
  completedSteps: number;
  totalSteps: number;
  animationDuration: number;
  incompleteColor: string;
};

export const getProgynyProgressBarProps = (currentRouteName: string | undefined): ProgressBarProps => {
  let completedSteps = 0;

  switch (currentRouteName) {
    case 'RouteProgynyWizardStartDate':
      completedSteps = 1;
      break;

    case 'RouteProgynyWizardTriggerDate':
      completedSteps = 1;
      break;

    case 'RouteProgynyWizardDosageCheck':
      completedSteps = 2;
      break;

    case 'RouteProgynyWizardLeftoverMeds':
      completedSteps = 3;
      break;

    default:
  }

  return {
    completedSteps,
    totalSteps: 3,
    animationDuration: 1000,
    incompleteColor: COLORS.BACKGROUND_COLORS.PINK_LIGHT,
  };
};
